import React, {SetStateAction} from "react";
import {
	Week,
	DragAndDrop,
	Inject,
	Resize,
	ScheduleComponent,
	ViewDirective,
	ViewsDirective
} from "../../../components/SimpleSchedule";

interface AgendaProps {
	schedules: any,
	callback: (item: React.SetStateAction<undefined>) => void
}

export const NextSchedules = ({schedules, callback}: AgendaProps) => {

	const onDragStart = (arg: { navigation: { enable: boolean; }; }) => {
		arg.navigation.enable = true;
	};

	type DateType =  "Day" | "Week" | "WorkWeek" | "Month" | "Year" | "Agenda" | "MonthAgenda" | "TimelineDay" | "TimelineWeek" | "TimelineWorkWeek" | "TimelineMonth" | "TimelineYear" | undefined

	return (
		<div className="flex flex-wrap justify-center gap-1 items-center">
			<div className="md:w-800 bg-white dark:text-gray-200 dark:bg-secondary-dark-bg rounded-2xl p-6 m-3">
				<ScheduleComponent
					height="450px"
					ref={(schedule: any) => callback(schedule as unknown as SetStateAction<undefined>)}
					selectedDate={new Date()}
							views={['Week']}
							currentView={'Week'}
					eventSettings={{ dataSource: schedules }}
					dragStart={onDragStart}
					firstDayOfWeek={1}
				>
					<ViewsDirective>
						{ ['Week'].map((item) => <ViewDirective key={item} option={item as DateType} />)}
					</ViewsDirective>
					<Inject services={[Week, Resize, DragAndDrop]} />
				</ScheduleComponent>
			</div>
		</div>
	);
};

